module.exports = __webpack_public_path__ + "img/CoinbaseOnramp2.7b4d2007.png";